export const MONEY_PAGES = [
  {
    slug: 'flower',
    label: 'Flower',
    h1: 'Cannabis Flower in Washington, DC',
    title: 'Cannabis Flower in Washington, DC | Majestic Greens DMV',
    meta: 'Shop premium cannabis flower in Washington, DC — exotic and indoor strains with online ordering, pickup at 425 7th St NW, and delivery across the District. Adults 21+.',
    ecwidSlug: 'exotic',
    intro: [
      'Majestic Greens DMV keeps a rotating flower menu at our downtown Washington, DC shop — exotic drops, indoor favorites, and value shake, all listed live so what you see online is what is actually available. We are located at 425 7th St NW, on the edge of Penn Quarter and Chinatown, and we serve the entire District.',
      'Shoppers can browse by strain type — indica, sativa, and hybrid — or go straight to the exotic shelf for the latest top-shelf arrivals. Every product page shows current pricing and available sizes before you check out.',
      'Order online in a couple of minutes: add flower to your cart, choose pickup or delivery, upload your ID, and our team verifies your order. Pickup is at 425 7th St NW; delivery runs across Washington, DC with a $40 minimum.',
    ],
    links: [
      { to: '/shop/indica', label: 'Indica strains' },
      { to: '/shop/sativa', label: 'Sativa strains' },
      { to: '/shop/hybrid', label: 'Hybrid strains' },
      { to: '/shop/exotic', label: 'Exotic flower' },
    ],
    faq: [
      { q: 'What cannabis flower do you carry in Washington, DC?', a: 'Our live menu carries exotic flower, indoor strains, and shake, organized by indica, sativa, and hybrid. Availability changes, so the online menu always shows what is actually in stock.' },
      { q: 'Can I order flower online for pickup?', a: 'Yes. Browse the menu, check out online, and pick up at 425 7th St NW, Washington, DC 20004 after a quick verification.' },
      { q: 'Is there a minimum order for flower delivery in DC?', a: 'Yes — our minimum order is $40, for both pickup and delivery across the District.' },
    ],
  },
  {
    slug: 'edibles',
    label: 'Edibles',
    h1: 'Cannabis Edibles in Washington, DC',
    title: 'Cannabis Edibles in Washington, DC | Majestic Greens DMV',
    meta: 'Order cannabis edibles in Washington, DC — gummies and more from Majestic Greens DMV, 425 7th St NW. Online ordering, pickup or DC delivery. Adults 21+.',
    ecwidSlug: 'edibles',
    intro: [
      'Our edibles shelf at Majestic Greens DMV covers gummies and other clearly labeled, portioned options from brands DC shoppers ask for by name. The online menu is live, so availability and pricing on the site match the shop at 425 7th St NW.',
      'Every edible we stock is packaged with its contents and servings printed on the label, so you know exactly what you are buying before you order. If you are new to edibles, our team can answer product questions by phone at (202) 320-7287.',
      'Ordering works the same as everything else in the store: build your cart online, choose pickup or delivery, upload your ID, and check out. Delivery covers all of Washington, DC with a $40 minimum.',
    ],
    links: [
      { to: '/shop/edibles', label: 'Full edibles menu' },
      { to: '/flower', label: 'Cannabis flower' },
      { to: '/vapes', label: 'Vape products' },
      { to: '/deals', label: 'Deals & bundles' },
    ],
    faq: [
      { q: 'What edibles are available in Washington, DC?', a: 'Our menu focuses on gummies and similar portioned edibles from established brands. Check the live menu for current stock — it updates in real time.' },
      { q: 'Do I need ID to buy edibles?', a: 'Yes. All customers must be 21 or older with a valid government-issued photo ID, verified during checkout.' },
      { q: 'Can edibles be delivered in DC?', a: 'Yes — we deliver across Washington, DC. The minimum order is $40, and delivery orders are paid electronically.' },
    ],
  },
  {
    slug: 'pre-rolls',
    label: 'Pre-Rolls',
    h1: 'Cannabis Pre-Rolls in Washington, DC',
    title: 'Cannabis Pre-Rolls in Washington, DC | Majestic Greens DMV',
    meta: 'Shop cannabis pre-rolls in Washington, DC at Majestic Greens DMV — singles and packs with online ordering, pickup at 425 7th St NW, and DC-wide delivery. Adults 21+.',
    ecwidSlug: 'prerolls',
    intro: [
      'Pre-rolls are the grab-and-go favorite at our downtown DC shop. Majestic Greens DMV stocks singles and multi-packs across indica, sativa, and hybrid strains, all listed on the live menu with current pricing.',
      'Because our menu updates in real time, you can check what pre-rolls are in stock before you make the trip to 425 7th St NW — or skip the trip and order delivery anywhere in Washington, DC.',
      'Checkout takes a couple of minutes: add to cart, choose pickup or delivery, upload your ID, and our team verifies your order before fulfillment. The minimum order is $40.',
    ],
    links: [
      { to: '/shop/prerolls', label: 'Full pre-rolls menu' },
      { to: '/flower', label: 'Cannabis flower' },
      { to: '/shop/exotic', label: 'Exotic flower' },
      { to: '/deals', label: 'Deals & bundles' },
    ],
    faq: [
      { q: 'Do you sell pre-roll packs in Washington, DC?', a: 'Yes — we carry singles and multi-packs across different strains. The live menu shows what is available right now.' },
      { q: 'Can I get pre-rolls delivered in DC?', a: 'Yes. We deliver across the District with a $40 minimum order. Delivery orders are paid electronically.' },
      { q: 'Where do I pick up a pre-roll order?', a: 'Pickup is at our shop at 425 7th St NW, Washington, DC 20004 — open daily from 10:00 AM to 11:00 PM.' },
    ],
  },
  {
    slug: 'vapes',
    label: 'Vapes',
    h1: 'Cannabis Vape Products in Washington, DC',
    title: 'Cannabis Vape Products in Washington, DC | Majestic Greens DMV',
    meta: 'Cannabis vape cartridges and disposable vapes in Washington, DC — shop Majestic Greens DMV online for pickup at 425 7th St NW or delivery across DC. Adults 21+.',
    ecwidSlug: 'cartridges',
    intro: [
      'Majestic Greens DMV carries both 510-thread cartridges and all-in-one disposable vapes at our downtown Washington, DC shop. The live menu shows exactly what is in stock — hardware type, size, and price — before you order.',
      'Cartridges fit standard 510 batteries, while disposables come ready to use with nothing extra needed. If you are not sure which format suits you, call (202) 320-7287 and the team will walk you through the current options.',
      'Order online for pickup at 425 7th St NW or delivery anywhere in the District. Upload your ID at checkout, meet the $40 minimum, and our team verifies and fulfills your order.',
    ],
    links: [
      { to: '/shop/cartridges', label: 'Vape cartridges' },
      { to: '/shop/disposable-vapes', label: 'Disposable vapes' },
      { to: '/flower', label: 'Cannabis flower' },
      { to: '/deals', label: 'Deals & bundles' },
    ],
    faq: [
      { q: 'What is the difference between cartridges and disposable vapes?', a: 'Cartridges attach to a reusable 510-thread battery. Disposables are all-in-one devices that need no separate battery. Both are on the live menu with sizes and pricing.' },
      { q: 'Do you deliver vapes in Washington, DC?', a: 'Yes — delivery covers the entire District with a $40 minimum order, paid electronically.' },
      { q: 'Do I need to be 21 to buy vape products?', a: 'Yes. Every customer must be 21 or older with a valid government-issued photo ID.' },
    ],
  },
  {
    slug: 'concentrates',
    label: 'Concentrates',
    h1: 'Cannabis Concentrates in Washington, DC',
    title: 'Cannabis Concentrates in Washington, DC | Majestic Greens DMV',
    meta: 'Shop cannabis concentrates in Washington, DC — wax, diamonds and extracts at Majestic Greens DMV, 425 7th St NW. Online ordering, pickup or DC delivery. Adults 21+.',
    ecwidSlug: 'concentrates',
    intro: [
      'For shoppers who prefer extracts, Majestic Greens DMV stocks a concentrates selection that typically includes wax, diamonds, and similar formats from known producers. Everything on the site is live inventory from our shop at 425 7th St NW in downtown DC.',
      'Concentrates are a product category most familiar to experienced consumers. Each listing on our menu shows format, size, and current pricing, and our team is happy to answer product questions by phone before you order.',
      'Checkout online in minutes — pickup at the shop or delivery across Washington, DC with a $40 minimum. A valid 21+ ID is verified for every order.',
    ],
    links: [
      { to: '/shop/concentrates', label: 'Full concentrates menu' },
      { to: '/flower', label: 'Cannabis flower' },
      { to: '/vapes', label: 'Vape products' },
      { to: '/deals', label: 'Deals & bundles' },
    ],
    faq: [
      { q: 'What concentrates do you carry in Washington, DC?', a: 'Our selection typically includes wax, diamonds, and similar extracts. The live menu always reflects what is actually in stock.' },
      { q: 'Can I order concentrates for delivery in DC?', a: 'Yes — delivery is available across the District with a $40 minimum, paid electronically.' },
      { q: 'Where is pickup for concentrate orders?', a: 'At Majestic Greens DMV, 425 7th St NW, Washington, DC 20004 — open daily, 10:00 AM to 11:00 PM.' },
    ],
  },
];
